import { DashedFocusBorder } from 'components/Common/DashedFocusBorder';
import styled from 'styled-components';

export const Container = styled.div`
    padding: 16px;
`;
export const CSSContactItem = styled.div`
    border-bottom: ${(props) => props.theme.color.grey2};
    border-bottom-style: solid;
    border-bottom-width: 1px;
    background-color: ${(props) => props.theme.color.white};
    padding: ${(props) => props.theme.space.md}px;
    display: flex;
    align-items: center;
    flex-direction: row;
    transition: background-color 0.2s;
`;

export const CSSContactItemA = styled.a`
    border-bottom: ${(props) => props.theme.color.grey2};
    border-bottom-style: solid;
    border-bottom-width: 1px;
    background-color: ${(props) => props.theme.color.white};
    padding: ${(props) => props.theme.space.md}px;
    display: flex;
    align-items: center;
    flex-direction: row;
    transition: background-color 0.2s;
    &:hover {
        background-color: ${(props) => props.theme.color.grey2};
        text-decoration: none;
        color: ${(props) => props.theme.color.black};
    }
    ${DashedFocusBorder()}
`;

export const ContactImg = styled.div<{ color: string }>`
    border-radius: 50%;
    background-color: ${(props) => props.color};
    width: ${(props) => props.theme.size.xl}px;
    height: ${(props) => props.theme.size.xl}px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    margin-right: 8px;
`;
